import { render, staticRenderFns } from "./SyncTaskList.vue?vue&type=template&id=b1a14576&scoped=true&"
import script from "./SyncTaskList.vue?vue&type=script&lang=ts&"
export * from "./SyncTaskList.vue?vue&type=script&lang=ts&"
import style0 from "./SyncTaskList.vue?vue&type=style&index=0&id=b1a14576&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a14576",
  null
  
)

export default component.exports